import React, { FC } from "react";
import { FormControlLabel } from "@mui/material";

import { Radio, RadioGroup, Stack, Typography } from "@components/base";

const Radios: FC = () => {
  return (
    <Stack spacing={4}>
      <Typography variant="h2">Radios</Typography>
      <Stack spacing={2}>
        <Typography variant="subtitle2">Default</Typography>
        <RadioGroup>
          <FormControlLabel control={<Radio checked />} label="Radio checked" />
          <FormControlLabel control={<Radio checked={false} />} label="Radio" />
          <FormControlLabel
            control={<Radio checked={false} disabled />}
            label="Disabled"
          />
        </RadioGroup>
      </Stack>
      <Stack spacing={2}>
        <Typography variant="subtitle2">Small</Typography>
        <RadioGroup>
          <FormControlLabel
            control={<Radio checked size="small" />}
            label="Radio checked"
          />
          <FormControlLabel
            control={<Radio checked={false} size="small" />}
            label="Radio"
          />
        </RadioGroup>
      </Stack>
      <Stack spacing={2}>
        <Typography variant="subtitle2">Horizontal</Typography>
        <RadioGroup row>
          <FormControlLabel
            control={<Radio checked size="small" />}
            label="Radio checked"
          />
          <FormControlLabel
            control={<Radio checked={false} size="small" />}
            label="Radio"
          />
        </RadioGroup>
      </Stack>
    </Stack>
  );
};

export default Radios;
